import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/site-working-hours-exception/:hoursId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    siteId: string;
    hoursId: string;
    parkingId: string;
}
const mutationFn = ({ siteId, hoursId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { siteId, hoursId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteWorkingHoursException };
